<template>
	<div class="footer">
		<div class="container footer-container">	
			<div class="left">
				<p>
					<img src="../../assets/img/c56.png" alt="" />
					<span>
						扫描关注<br>中国物流公众号
					</span>
				</p>
				<p>
					<img src="../../assets/img/so56.png" alt="" />
					<span>
						扫描关注<br>SO56公众号
					</span>
				</p>
			</div>
			<div class="right">
				<p class="line-text">
					<b class="icon icon-link"></b>
					<span>http://www.c56.cn</span>
				</p>
				<p class="line-text">
					<b class="icon icon-email"></b>
					<span>so56@so56.net</span>
				</p>
				<p class="line-text">
					<b class="icon icon-address"></b>
					<span class="wladdress">中国物流股份有限公司</span><br>
					<span class="zaddress">北京市丰台区南四环西路188号总部基地6区17楼A座8层</span>
				</p>
				<p class="line-text">
					<b class="icon icon-phone"></b>
					<span style="position: relative;top: -22px;">010-83673688</span>
				</p>
				<p class="bottom">
					Copyright So56.net 版权所有 &nbsp; <a href="http://beian.miit.gov.cn/" style="color: #979ea7;">京ICP备05047576号</a>
				</p>
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import '../../assets/stylus/base.styl';
	.footer
		background: #f7f7f7
		padding: 30px 0
		.footer-container
			display: flex
			.left
				display: flex
				flex: 0 0 35%
				p
					flex: 1
					margin-right: 50px
					text-align: center
					color: #061f3e
					img
						width: 90%
					span
						display: block
					    margin-top: 5px
				        line-height: 20px
			.right
				flex: 1
				padding-top: 30px
				.line-text
					display: inline-block
					width: 59%
					margin-bottom: 15px
					&:nth-of-type(2n)
						width: 30%
					.wladdress
						display: inline-block
						line-height: 30px
					.zaddress
						margin-left: 48px
					.icon
						display: inline-block
						width: 24px
						height: 24px
						margin-right: 20px
						position: relative
						top: 6px
						&.icon-link
							background: url('../../assets/img/images/icon18.png') no-repeat
							background-size: 100%
						&.icon-email
							background: url('../../assets/img/images/icon19.png') no-repeat
							background-size: 100%
						&.icon-address
							background: url('../../assets/img/images/icon20.png') no-repeat
							background-size: 100%
							position: relative
							top: 20px
						&.icon-phone
							background: url('../../assets/img/images/icon21.png') no-repeat
							background-size: 100%
							position: relative
							top: -16px
				.bottom
					color: #979ea7
					margin-top: 30px
	@media (max-width: 1400px)
		.footer
			.footer-container 
				.left 
					p
						margin-right: 20px
				.right
					.line-text
						.zaddress
							margin-left: 32px
						.icon
							margin-right: 5px
			
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue